<template>
  <div class="mt-4">
    <div class="total-number">
      <span class="text-3xl font-bold">
        {{ data.needed }}
      </span>
      {{ $t("dashboard.total") }}
    </div>
    <div>
      <div class="progress h-[15px]">
        <div class="bar" :style="{ width: earnedCredit }"></div>
      </div>
      <div class="md-layout note">
        <div
          class="md-layout-item md-small-size-100 md-size-50 flex items-center"
        >
          <div
            class="note-dark h-[4px] w-[30px] rounded-full mt-1.5 mr-3"
          ></div>
          <div class="text-sm">
            <p class="note-title">{{ $t("dashboard.earn_credit") }}</p>
            <p class="font-bold">
              {{ data.earned }} {{ $t("dashboard.credits") }}
            </p>
          </div>
        </div>
        <div
          class="md-layout-item md-small-size-100 md-size-50 mt-3 md:mt-0 flex items-center"
        >
          <div
            class="note-light h-[4px] w-[30px] rounded-full mt-1.5 mr-3"
          ></div>
          <div class="text-sm">
            <p class="note-title">{{ $t("dashboard.remaining") }}</p>
            <p class="font-bold">
              {{ data.missing }} {{ $t("dashboard.credits") }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "credits-percentage",
  props: ["data"],
  computed: {
    earnedCredit() {
      let data = (this.data.earned / this.data.needed) * 100;
      return Math.round(data) + "%";
    }
  }
};
</script>
<style lang="scss" scoped>
.total-number {
  color: #333334;
  span {
    color: #11263c;
  }
}
.note {
  &-dark {
    background-color: #7459d9;
  }
  &-light {
    background-color: #e3def7;
  }
  &-title {
    color: #333334;
  }
}
</style>
